import apiClient from './api';

/** A company's logo (PNG, JPEG, GIF or WebP, at most 256 KB), uploaded by our staff. Returns its address. */
export async function uploadCompanyLogo(tenant: string, file: File): Promise<string> {
  const form = new FormData();
  form.append('file', file);
  try {
    const r = await apiClient.post<{ logo: string }>(`/v2/admin/companies/${tenant}/logo`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return r.data.logo;
  } catch (e: any) {
    throw new Error(e?.response?.data?.detail ?? e?.response?.data?.message ?? e?.message ?? 'upload failed');
  }
}

export async function removeCompanyLogo(tenant: string): Promise<void> {
  await apiClient.delete(`/v2/admin/companies/${tenant}/logo`);
}
